module.exports = __webpack_public_path__ + "static/media/18.8be8a327.jpg";